// extracted by mini-css-extract-plugin
export var alignCenter = "_6p-d";
export var bannerShown = "_6p-6";
export var buttonContent = "_6p-0";
export var cardList = "_6p-1";
export var centerContent = "_6p-2";
export var chevron = "_6p-3";
export var closePanelButton = "_6p-k";
export var conversationContextContainer = "_6p-l";
export var conversationDetailContainer = "_6p-4";
export var detailWrapper = "_6p-7";
export var dropdownButton = "_6p-e";
export var dropdownTitle = "_6p-9";
export var fullHeight = "_6p-5";
export var hidden = "_6p-a";
export var icon = "_6p-b";
export var mergeSuggestionWrapper = "_6p-m";
export var panel = "_6p-i";
export var portalButtonsWrapper = "_6p-c";
export var right = "_6p-j";
export var tableSummaryContainer = "_6p-8";
export var tableSummaryHeader = "_6p-g";
export var threeDotsButton = "_6p-f";
export var wide = "_6p-h";